class Speedtest {
    constructor(megabyte, callback, forceDownload = false) {
        this.megabyte = megabyte;
        this.callback = callback;
        this.forceDownload = forceDownload;
        this.downloadSpeed();
        return megabyte;
    }

    downloadSpeed() {
        const native = navigator.connection && navigator.connection.downlink;
        const speed = native || this.load();

        if (this.forceDownload || !speed) {
            this.makeTestWithRequest();
        } else {
            this.callback(speed, native ? 'native' : 'saved request');
        }
    }

    makeTestWithRequest() {
        const START = new Date().getTime();
        const URL = `/_Resources/Static/Packages/GesagtGetan.AutoplayVideo/Assets/${this.megabyte}mb.bin?id=${START}`;
        const REQUEST = new XMLHttpRequest();
        REQUEST.open('GET', URL);
        REQUEST.setRequestHeader('Content-type', 'application/octet-stream');
        REQUEST.onload = () => {
            if (REQUEST.readyState != 4) {
                return;
            }
            if (REQUEST.status >= 200 && REQUEST.status < 300) {
                const SIZE = (REQUEST.responseText.data || REQUEST.responseText).length;
                const TIME = new Date().getTime() - START;
                // 125000 byte/s is 1 Mb/s divided with 1000 (miniseconds) = 125
                const SPEED = Math.round((SIZE / TIME / 125) * 10) / 10;

                if (!this.native) {
                    // Save value in the local storage
                    this.save(SPEED);
                }
                this.callback(SPEED, 'request');
            }
        };
        REQUEST.send();
    }

    save(speed) {
        // Save value for 10 minutes 10 * 60 * 1000 = 600000
        const EXPIRATION_MS = 600000;
        const RECORD = { speed, timestamp: new Date().getTime() + EXPIRATION_MS };
        localStorage.setItem(`Speedtest-${this.megabyte}`, JSON.stringify(RECORD));
        return speed;
    }

    load() {
        const RECORD = JSON.parse(localStorage.getItem(`Speedtest-${this.megabyte}`));
        if (!RECORD) {
            return false;
        }
        return new Date().getTime() < RECORD.timestamp && JSON.parse(RECORD.speed);
    }
}

export default Speedtest;
